export default "/images/b613aba51fda186688971d576745c226.avif";